import { parseISO } from "date-fns";

import Highlight from "@/components/Highlight";
import { DATE_FORMAT, SOURCE, Source } from "@/constants";
import { useEpisode } from "@/containers/Episode/context";
import Insights from "@/containers/Episode/partials/Insights";
import PopularityScore from "@/containers/Episode/partials/PopularityScore";
import PRValue from "@/containers/Episode/partials/PRValue";
import Reach from "@/containers/Episode/partials/Reach";
import Toplist from "@/containers/Episode/partials/Toplist";
import TranscriptStatus from "@/containers/Episode/partials/TranscriptStatus";
import { useI18n } from "@/contexts/i18nContext";
import { cx } from "@/utils";

import EpisodeSentiment from "../Sentiment";
import Tags from "../Tags";

import styles from "./Footer.module.css";

const TIME_SENSITIVE_MEDIA: Source[] = [SOURCE.RADIO, SOURCE.TV];

const Footer: React.FunctionComponent<{ className?: string }> = ({
  className,
  ...props
}) => {
  const {
    post_data,
    hideTags,
    published_date,
    source,
    is_text_source,
    hideReach,
    hideSentiment,
    hidePrValue,
  } = useEpisode();

  const { formatDate } = useI18n();

  // Radio/TV sources should display the time as well as the date
  const datePrecision = TIME_SENSITIVE_MEDIA.includes(source)
    ? DATE_FORMAT.LONG_WITH_TIME
    : DATE_FORMAT.LONG;

  const formattedPublishDate = formatDate(
    parseISO(post_data?.published_date || published_date),
    datePrecision
  );

  return (
    <>
      <div className={cx(styles.root, className)} {...props}>
        <Highlight label={formattedPublishDate} />
        {!is_text_source && <TranscriptStatus />}
        <Insights />
        <Toplist />
        {!hideReach && <Reach />}
        {!hidePrValue && <PRValue />}
        <PopularityScore />
        {!hideSentiment && <EpisodeSentiment />}

        {!hideTags && <Tags />}
      </div>
    </>
  );
};

export default Footer;
